export const WALLET_TRANSACTIONS_PAGE_SIZE_OPTIONS = [7, 10, 15, 20] as const

export type WalletTransactionsPageSize =
  (typeof WALLET_TRANSACTIONS_PAGE_SIZE_OPTIONS)[number]

export const DEFAULT_WALLET_TRANSACTIONS_PAGE_SIZE: WalletTransactionsPageSize = 7

/**
 * Transactions are fetched in one batch so the brand filter and the pagination
 * can both work off the full dataset. If the response reports a higher total,
 * the page re-requests with that total as the limit.
 */
export const WALLET_TRANSACTIONS_FETCH_LIMIT = 200
